export default __webpack_public_path__ + "static/1792-8faef35c7ba83b4c767f20b6a02831b5.gif";